import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("config-comparator"),
  // No `endpoint`: this config only supplies the route, role and menu entry. There is
  // no /api/v1/config-comparator — the page fetches directly.
  roleView: [ROLE.EMZ_DEVELOPER],
  roleAdmin: [ROLE.EMZ_DEVELOPER],
  baseRoute: "config-comparator",
  singularName: (t) => t("Config Comparator"),
  name: (t) => t("Config Comparator"),
});

export default conf;
